import { useState, useEffect, useRef } from 'react';
import { getPaymentStatus, PaymentStatusResponse } from '../lib/stripe';

export const usePaymentStatus = (paymentId: string | null, enabled: boolean = true) => {
  const [status, setStatus] = useState<PaymentStatusResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!paymentId || !enabled) {
      return;
    }

    const checkStatus = async () => {
      try {
        console.log(`Checking status for paymentId: ${paymentId}`);
        setLoading(true);
        setError(null);
        const result = await getPaymentStatus(paymentId);
        console.log(`Received result:`, result);
        setStatus(result);
        
        // Stop polling if payment is completed
        if (result.status === 'completed') {
          console.log(`Payment completed, stopping polling`);
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
        } else {
          console.log(`Payment not completed yet, status: ${result.status}`);
        }
      } catch (err) {
        console.error(`Error:`, err);
        setError(err instanceof Error ? err.message : 'Failed to check payment status');
      } finally {
        setLoading(false);
      }
    };

    // Check immediately
    checkStatus();

    // Then poll every 3 seconds
    intervalRef.current = setInterval(checkStatus, 3000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [paymentId, enabled]);

  const stopPolling = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  return {
    status,
    loading,
    error,
    stopPolling,
  };
}; 